import { render } from "./elecBoardOfco1Thread.vue?vue&type=template&id=65ac8467"
import script from "./elecBoardOfco1Thread.vue?vue&type=script&lang=js"
export * from "./elecBoardOfco1Thread.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__